(function() {
  'use strict';
  if (window.__gmAuthBooted) return;
  window.__gmAuthBooted = true;

  var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';

  var currentUser = null;
  var currentProfile = null;
  var accountDetailsEditMode = false;
  var profileInlineEdit = null;
  var profileChangePending = null;
  var profileChangeConfirmEl = null;
  var PROFILE_ACCOUNT_FIELDS = [
    { key: 'firstname', label: 'first name', type: 'text' },
    { key: 'lastname', label: 'last name', type: 'text' },
    { key: 'username', label: 'username', type: 'text' },
    { key: 'password', label: 'password', type: 'password' },
    { key: 'email', label: 'email', type: 'email' },
    { key: 'phone', label: 'phone', type: 'tel' },
    { key: 'birthday', label: 'birthday', type: 'date' },
    { key: 'marketing_opt_in', label: 'updates', type: 'toggle' }
  ];
  var profilePasswordEditOpen = false;
  var profileActivePanel = 'orders';
  var accountMessageTimer = null;
  var authPopupTimer = null;
  var SESSION_REFRESH_BUFFER_SEC = 60;
  var TITLE_COLORS = ['#F3E9DF', '#B884C8', '#F5A08E', '#C42F86', '#2E5E8F', '#B7B66C', '#2A2333'];
  var PROFILE_ROW_FIELDS = [
    'email', 'username', 'firstname', 'lastname', 'phone', 'birthday',
    'marketing_opt_in', 'marketing_opt_in_at', 'shopify_customer_id', 'shopify_synced_at',
    'is_admin'
  ];

  async function readFetchError(res) {
    try {
      var data = await res.json();
      if (!data) return 'request failed (' + res.status + ')';
      if (typeof data.message === 'string') return data.message;
      if (typeof data.error === 'string') return data.error;
      if (data.error && typeof data.error === 'object') return data.error.message || data.error.details || JSON.stringify(data.error);
      if (data.details) return String(data.details);
      return JSON.stringify(data);
    } catch (e) {
      return 'request failed (' + res.status + ')';
    }
  }

  async function fetchUserProfileRow(token, userId) {
    if (!token || !userId) return null;
    // Full PII comes from security-definer RPC (table SELECT is id/username only).
    try {
      var rpcRes = await fetch(SUPABASE_URL + '/rest/v1/rpc/get_my_profile', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + token
        },
        body: '{}'
      });
      if (rpcRes.ok) {
        var rpcRows = await rpcRes.json();
        if (Array.isArray(rpcRows) && rpcRows.length) return rpcRows[0];
        if (rpcRows && typeof rpcRows === 'object' && rpcRows.id) return rpcRows;
      }
    } catch (e) { /* fall through */ }

    var res = await fetch(
      SUPABASE_URL + '/rest/v1/profiles?id=eq.' + encodeURIComponent(userId) + '&select=' + PROFILE_ROW_FIELDS.join(','),
      { headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + token } }
    );
    if (!res.ok) return null;
    var rows = await res.json();
    if (!Array.isArray(rows) || !rows.length) return null;
    return rows[0];
  }

  function getProfileDataSource(user) {
    var meta = (user && user.user_metadata) || {};
    var profile = currentProfile || {};
    return {
      email: (user && user.email) || profile.email || '',
      username: profile.username != null ? profile.username : (meta.username || ''),
      firstname: profile.firstname != null ? profile.firstname : (meta.firstname || ''),
      lastname: profile.lastname != null ? profile.lastname : (meta.lastname || ''),
      phone: profile.phone != null ? profile.phone : (meta.phone || ''),
      birthday: profile.birthday != null ? profile.birthday : (meta.birthday || ''),
      marketing_opt_in: profile.marketing_opt_in != null ? !!profile.marketing_opt_in : !!meta.marketing_opt_in,
      marketing_opt_in_at: profile.marketing_opt_in_at || meta.marketing_opt_in_at || null
    };
  }

  function mergeProfileRow(profileRow) {
    currentProfile = profileRow || null;
    syncAdminNav();
  }
  var PROFILE_SIGNIN_CLOSED = 'sign in';
  var PROFILE_CREATE_CLOSED = 'Create Account';
  var PROFILE_LABEL_OPEN = 'Fill Out Info Below';

  var profileDropdown;
  var loggedOutViewEl;
  var signupFormEl;
  var signinFormEl;
  var profileToggleBtn;
  var profileSigninBtn;
  var profileInstagramBtn;
  var accountOverlay;

  function $(id) { return document.getElementById(id); }

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getPageEl() {
    return document.querySelector('.gm-page');
  }

  function isProfilePage() {
    if (document.querySelector('.gm-profile-page')) return true;
    if (document.getElementById('profile-sections-nav')) return true;
    if (document.getElementById('profile-panel-account')) return true;
    return /\/pages\/profile\/?$/i.test(window.location.pathname);
  }

  var PROFILE_PANEL_IDS = ['orders', 'account', 'signout'];

  function getInitialProfilePanel() {
    var hash = (window.location.hash || '').replace(/^#/, '').toLowerCase();
    if (hash === 'shipping' || hash === 'account') return 'account';
    if (PROFILE_PANEL_IDS.indexOf(hash) >= 0) return hash;
    return 'orders';
  }

  function openAccountOverlay() {
    if (isProfilePage()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (!accountOverlay) return;
    accountOverlay.classList.add('is-open');
    accountOverlay.setAttribute('aria-hidden', 'false');
  }

  function closeAccountOverlay() {
    if (isProfilePage()) return;
    if (!accountOverlay) return;
    accountOverlay.classList.remove('is-open');
    accountOverlay.setAttribute('aria-hidden', 'true');
    setProfilePanelOpen(false);
  }

  function colorizeLetters(text) {
    var colors = (window.__gmTitleColors && window.__gmTitleColors.colors) || TITLE_COLORS;
    var spread = (window.__gmTitleColors && window.__gmTitleColors.spreadIndex) ||
      function(i, t) { return i % colors.length; };
    var html = '';
    var letterIndex = 0;
    var nonSpace = 0;
    for (var n = 0; n < text.length; n++) {
      if (text.charAt(n) !== ' ') nonSpace++;
    }
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (ch === ' ') {
        html += '<span class="cs-greeting-letter cs-title-space"> </span>';
      } else {
        var color = colors[spread(letterIndex, nonSpace || 1)];
        html += '<span class="cs-greeting-letter" style="color:' + color + '">' + escHtml(ch) + '</span>';
        letterIndex++;
      }
    }
    return html;
  }

  function setGreeting(isReturning, firstname) {
    var el = $('cs-greeting');
    if (!el) return;
    var name = firstname || 'friend';
    var text = isReturning ? ('welcome back, ' + name) : ('hi, ' + name);
    el.innerHTML = colorizeLetters(text);
  }

  function hideAccountMessage() {
    var el = $('account-message');
    if (!el) return;
    el.classList.remove('visible', 'is-success');
    el.textContent = '';
    if (accountMessageTimer) clearTimeout(accountMessageTimer);
  }

  function showAccountMessage(message, isSuccess) {
    var el = $('account-message');
    if (!el) return;
    el.textContent = toUserFacingMessage(message);
    el.classList.toggle('is-success', !!isSuccess);
    el.classList.add('visible');
    if (accountMessageTimer) clearTimeout(accountMessageTimer);
    accountMessageTimer = setTimeout(hideAccountMessage, isSuccess ? 4000 : 6000);
  }

  function toUserFacingMessage(message) {
    var msg = String(message || '').trim();
    if (!msg) return 'something went wrong — please try again';
    if (/access token|expired|revoked|malformed|invalid for other reasons|jwt|not authenticated/i.test(msg)) {
      return 'your session expired — please sign in again';
    }
    if (/rls|row level|postgres|supabase|shopify api|edge function|sql|policy|violates|duplicate key|pgrst/i.test(msg)) {
      return 'could not save your changes — please try again';
    }
    if (/email.*confirm|confirmation/i.test(msg)) {
      return 'check your email to confirm the new address';
    }
    return msg;
  }

  function initTouchDateField(inputId) {
    var el = $(inputId);
    if (!el || el.type !== 'date') return;
    el.addEventListener('change', function() {
      if (el.value) el.dataset.userSet = 'true';
    });
    if (!('ontouchstart' in window) && !navigator.maxTouchPoints) return;
    el.setAttribute('readonly', 'readonly');
    function openPicker() {
      el.removeAttribute('readonly');
      window.setTimeout(function() {
        if (typeof el.showPicker === 'function') {
          try { el.showPicker(); return; } catch (e) { /* focus fallback */ }
        }
        el.focus({ preventScroll: true });
      }, 0);
    }
    el.addEventListener('click', openPicker);
    el.addEventListener('blur', function() {
      if (!el.value) el.setAttribute('readonly', 'readonly');
    });
  }

  async function isUsernameTakenByOther(username, userId) {
    try {
      var rpcRes = await fetch(SUPABASE_URL + '/rest/v1/rpc/username_is_taken', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + SUPABASE_ANON_KEY
        },
        body: JSON.stringify({ uname: username, exclude_id: userId || null })
      });
      if (rpcRes.ok) {
        var taken = await rpcRes.json();
        if (typeof taken === 'boolean') return taken;
      }
    } catch (e) { /* fall through */ }

    var res = await fetch(
      SUPABASE_URL + '/rest/v1/profiles?username=eq.' + encodeURIComponent(username) + '&select=id',
      { headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + SUPABASE_ANON_KEY } }
    );
    var rows = await res.json();
    if (!Array.isArray(rows) || !rows.length) return false;
    return rows[0].id !== userId;
  }

  async function saveUserProfile(token, userId, payload) {
    var headers = {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: 'Bearer ' + token,
      Prefer: 'return=minimal'
    };
    var res = await fetch(SUPABASE_URL + '/rest/v1/profiles?id=eq.' + encodeURIComponent(userId), {
      method: 'PATCH', headers: headers, body: JSON.stringify(payload)
    });
    if (res.ok || res.status === 204) return { ok: true };
    var patchError = await readFetchError(res);
    res = await fetch(SUPABASE_URL + '/rest/v1/profiles?on_conflict=id', {
      method: 'POST',
      headers: Object.assign({}, headers, { Prefer: 'return=minimal,resolution=merge-duplicates' }),
      body: JSON.stringify(Object.assign({ id: userId }, payload))
    });
    if (res.ok || res.status === 204) return { ok: true };
    return { ok: false, error: patchError || (await readFetchError(res)) };
  }

  function getAccountEditIssue(fields) {
    for (var i = 0; i < fields.length; i++) {
      var el = $(fields[i].id);
      if (!el) continue;
      var value = el.type === 'checkbox' ? (el.checked ? '1' : '') : el.value.trim();
      if (!value) return { el: el, label: fields[i].label };
    }
    var username = $('account-edit-username');
    if (username && !/^[a-zA-Z0-9_]{3,30}$/.test(username.value.trim())) {
      return { el: username, label: 'username (letters, numbers, underscore, 3–30 chars)' };
    }
    var email = $('account-edit-email');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      return { el: email, label: 'a valid email' };
    }
    return null;
  }

  function getProfileAccountFieldStyles() {
    return {
      row: '',
      label: '',
      value: ''
    };
  }

  function getProfileFieldDisplay(user, field) {
    var source = getProfileDataSource(user);
    if (field.key === 'email') return source.email || '';
    if (field.key === 'password') return 'Click To Change';
    if (field.key === 'marketing_opt_in') {
      return source.marketing_opt_in ? 'texts and emails on' : 'texts and emails off';
    }
    return source[field.key] || '';
  }

  function getProfileFieldRaw(user, field) {
    var source = getProfileDataSource(user);
    if (field.key === 'email') return source.email || '';
    if (field.key === 'password') return '';
    if (field.key === 'marketing_opt_in') return !!source.marketing_opt_in;
    return source[field.key] || '';
  }

  function getProfileFieldConfig(fieldKey) {
    for (var i = 0; i < PROFILE_ACCOUNT_FIELDS.length; i++) {
      if (PROFILE_ACCOUNT_FIELDS[i].key === fieldKey) return PROFILE_ACCOUNT_FIELDS[i];
    }
    return null;
  }

  function validateProfileFieldValue(fieldKey, profilePayload) {
    var field = getProfileFieldConfig(fieldKey);
    if (!field) return null;
    if (fieldKey === 'marketing_opt_in' || fieldKey === 'password') return null;
    var value = fieldKey === 'email' ? profilePayload.email : profilePayload[fieldKey];
    value = String(value || '').trim();
    if (!value) {
      if (field.optional) return null;
      return 'please enter ' + field.label;
    }
    if (fieldKey === 'username' && !/^[a-zA-Z0-9_]{3,30}$/.test(value)) {
      return 'username must be 3–30 letters, numbers, or underscores';
    }
    if (fieldKey === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'please enter a valid email';
    }
    return null;
  }

  function buildProfileAccountDetailsRow(field, displayValue, rawValue, styles) {
    if (field.key === 'marketing_opt_in') {
      var checked = rawValue ? ' checked' : '';
      return '<div class="cs-account-row gm-account-field gm-account-updates-field" data-field="marketing_opt_in">' +
        '<span class="cs-account-label">updates</span>' +
        '<label class="gm-account-updates-check">' +
          '<span class="gm-account-updates-text">texts and emails</span>' +
          '<input type="checkbox" class="gm-account-updates-input" data-field="marketing_opt_in"' +
            checked + ' aria-label="receive texts and emails about updates" />' +
        '</label>' +
      '</div>';
    }

    if (field.key === 'password') {
      if (profilePasswordEditOpen) {
        return '<div class="cs-account-row gm-account-field gm-account-password-field is-editing" data-field="password">' +
          '<span class="cs-account-label">password</span>' +
          '<div class="gm-account-password-form">' +
            '<input class="gm-account-inline-input gm-account-password-input" type="password" id="profile-password-current" name="current-password" placeholder="current password" autocomplete="current-password" />' +
            '<input class="gm-account-inline-input gm-account-password-input" type="password" id="profile-password-new" name="new-password" placeholder="new password" autocomplete="new-password" />' +
            '<div class="gm-account-password-actions">' +
              '<button type="button" class="gm-account-password-btn" id="profile-password-cancel">cancel</button>' +
              '<button type="button" class="gm-account-password-btn gm-account-password-btn--save" id="profile-password-save">save</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }

      return '<div class="cs-account-row gm-account-field gm-account-password-field" data-field="password">' +
        '<span class="cs-account-label gm-account-editable" data-field="password">password</span>' +
        '<button type="button" class="cs-account-value gm-account-editable gm-account-empty-value" data-field="password">Click To Change</button>' +
      '</div>';
    }

    var isEmpty = !displayValue;
    var placeholder = isEmpty ? 'enter' : displayValue;
    var emptyClass = isEmpty ? ' gm-account-empty-value' : '';
    return '<div class="cs-account-row gm-account-field" data-field="' + field.key + '">' +
      '<span class="cs-account-label gm-account-editable" data-field="' + field.key + '">' +
      escHtml(field.label) + '</span>' +
      '<button type="button" class="cs-account-value gm-account-editable' + emptyClass + '" data-field="' + field.key + '">' +
      escHtml(placeholder) + '</button></div>';
  }

  function closePasswordEdit(rerender) {
    profilePasswordEditOpen = false;
    if (rerender && currentUser) renderAccountDetails(currentUser);
  }

  async function openPasswordEdit() {
    if (!currentUser || !isProfilePage()) return;
    if (profileInlineEdit) await commitProfileFieldEdit();
    if (profileChangePending) cancelProfileChange();
    profilePasswordEditOpen = true;
    renderAccountDetails(currentUser);
    window.setTimeout(function() {
      var currentInput = $('profile-password-current');
      if (currentInput) currentInput.focus();
    }, 0);
  }

  async function submitPasswordChange() {
    if (!currentUser) return;
    var currentInput = $('profile-password-current');
    var newInput = $('profile-password-new');
    var saveBtn = $('profile-password-save');
    var currentPassword = currentInput ? currentInput.value : '';
    var newPassword = newInput ? newInput.value : '';

    if (!currentPassword || !newPassword) {
      showAccountMessage('enter your current password and a new password');
      if (!currentPassword && currentInput) currentInput.focus();
      else if (newInput) newInput.focus();
      return;
    }
    if (newPassword.length < 6) {
      showAccountMessage('new password must be at least 6 characters');
      if (newInput) newInput.focus();
      return;
    }
    if (currentPassword === newPassword) {
      showAccountMessage('new password must be different from your current password');
      if (newInput) newInput.focus();
      return;
    }

    var email = (currentUser.email || '').trim().toLowerCase();
    if (!email) {
      showAccountMessage('could not update password — missing account email');
      return;
    }

    if (saveBtn) saveBtn.disabled = true;
    if (currentInput) currentInput.disabled = true;
    if (newInput) newInput.disabled = true;

    try {
      var verifyRes = await fetch(SUPABASE_URL + '/auth/v1/token?grant_type=password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY
        },
        body: JSON.stringify({ email: email, password: currentPassword })
      });
      var verifyData = {};
      try { verifyData = await verifyRes.json(); } catch (e) { verifyData = {}; }

      if (!verifyData.access_token) {
        showAccountMessage('current password is incorrect');
        if (currentInput) {
          currentInput.disabled = false;
          currentInput.focus();
          currentInput.select();
        }
        if (newInput) newInput.disabled = false;
        if (saveBtn) saveBtn.disabled = false;
        return;
      }

      saveSession(verifyData, getStoredSession());

      var updateRes = await fetch(SUPABASE_URL + '/auth/v1/user', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + verifyData.access_token
        },
        body: JSON.stringify({ password: newPassword })
      });
      var updateData = {};
      try { updateData = await updateRes.json(); } catch (e) { updateData = {}; }

      if (!updateRes.ok || isAuthErrorResponse(updateRes, updateData)) {
        showAccountMessage(toUserFacingMessage(getErrorText(updateData) || 'could not update password'));
        if (currentInput) currentInput.disabled = false;
        if (newInput) newInput.disabled = false;
        if (saveBtn) saveBtn.disabled = false;
        return;
      }

      if (updateData && updateData.id) {
        currentUser = updateData;
        var session = getStoredSession();
        if (session) {
          session.user = updateData;
          localStorage.setItem('gm_session', JSON.stringify(session));
        }
      }

      profilePasswordEditOpen = false;
      renderAccountDetails(currentUser);
      showAccountMessage('password updated', true);
    } catch (e) {
      showAccountMessage('could not update password — try again');
      if (currentInput) currentInput.disabled = false;
      if (newInput) newInput.disabled = false;
      if (saveBtn) saveBtn.disabled = false;
    }
  }

  async function handleUpdatesCheckboxChange(input) {
    if (!input || !currentUser || !isProfilePage() || accountDetailsEditMode || profileChangePending) {
      return;
    }
    var nextValue = !!input.checked;
    var currentValue = !!getProfileDataSource(currentUser).marketing_opt_in;
    if (nextValue === currentValue) return;
    input.disabled = true;
    try {
      await saveProfileFieldUpdate('marketing_opt_in', nextValue);
    } finally {
      if (input.isConnected) input.disabled = false;
    }
  }

  function normalizeProfileFieldValue(fieldKey, rawValue) {
    if (fieldKey === 'email') return String(rawValue || '').trim().toLowerCase();
    return String(rawValue || '').trim();
  }

  function profileFieldValuesEqual(fieldKey, a, b) {
    return normalizeProfileFieldValue(fieldKey, a) === normalizeProfileFieldValue(fieldKey, b);
  }

  function formatProfileConfirmValue(fieldKey, rawValue) {
    var value = normalizeProfileFieldValue(fieldKey, rawValue);
    if (!value) return '(empty)';
    return value;
  }

  function ensureProfileChangeConfirmDialog() {
    if (profileChangeConfirmEl) return profileChangeConfirmEl;
    var root = document.createElement('div');
    root.className = 'gm-profile-change-confirm';
    root.id = 'gm-profile-change-confirm';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="gm-profile-change-confirm__backdrop" data-profile-change-dismiss></div>' +
      '<div class="gm-profile-change-confirm__panel" role="dialog" aria-modal="true" aria-labelledby="gm-profile-change-title">' +
        '<p class="gm-profile-change-confirm__title" id="gm-profile-change-title">Are You Sure You Want To Change?</p>' +
        '<p class="gm-profile-change-confirm__field" id="gm-profile-change-field"></p>' +
        '<div class="gm-profile-change-confirm__compare">' +
          '<div class="gm-profile-change-confirm__row">' +
            '<span class="gm-profile-change-confirm__label">Before</span>' +
            '<span class="gm-profile-change-confirm__value" id="gm-profile-change-old"></span>' +
          '</div>' +
          '<div class="gm-profile-change-confirm__row">' +
            '<span class="gm-profile-change-confirm__label">After</span>' +
            '<span class="gm-profile-change-confirm__value" id="gm-profile-change-new"></span>' +
          '</div>' +
        '</div>' +
        '<div class="gm-profile-change-confirm__actions">' +
          '<button type="button" class="gm-profile-change-confirm__btn" id="gm-profile-change-cancel">Cancel</button>' +
          '<button type="button" class="gm-profile-change-confirm__btn gm-profile-change-confirm__btn--confirm" id="gm-profile-change-confirm-btn">Confirm</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    root.querySelector('#gm-profile-change-cancel').addEventListener('click', cancelProfileChange);
    root.querySelector('#gm-profile-change-confirm-btn').addEventListener('click', confirmProfileChange);
    root.querySelector('[data-profile-change-dismiss]').addEventListener('click', cancelProfileChange);
    root.addEventListener('keydown', function(e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        cancelProfileChange();
      }
    });
    profileChangeConfirmEl = root;
    return root;
  }

  function closeProfileChangeConfirmUI() {
    if (!profileChangeConfirmEl) return;
    profileChangeConfirmEl.classList.remove('is-open');
    profileChangeConfirmEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gm-profile-change-confirm-open');
  }

  function showProfileChangeConfirm(pending) {
    if (!pending) return;
    var dialog = ensureProfileChangeConfirmDialog();
    var fieldLabel = pending.field && pending.field.label ? pending.field.label : 'detail';
    $('gm-profile-change-field').textContent = fieldLabel.toUpperCase();
    $('gm-profile-change-old').textContent = formatProfileConfirmValue(pending.fieldKey, pending.oldRaw);
    $('gm-profile-change-new').textContent = formatProfileConfirmValue(pending.fieldKey, pending.newRaw);
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gm-profile-change-confirm-open');
    var confirmBtn = $('gm-profile-change-confirm-btn');
    if (confirmBtn && confirmBtn.focus) confirmBtn.focus();
  }

  function cancelProfileChange() {
    profileChangePending = null;
    closeProfileChangeConfirmUI();
  }

  async function confirmProfileChange() {
    if (!profileChangePending || !currentUser) return;
    var pending = profileChangePending;
    profileChangePending = null;
    closeProfileChangeConfirmUI();
    await saveProfileFieldUpdate(pending.fieldKey, pending.newRaw);
  }

  function cancelProfileFieldEdit() {
    profileInlineEdit = null;
    if (currentUser) renderAccountDetails(currentUser);
  }

  function focusProfileInlineInput(input, field) {
    window.requestAnimationFrame(function() {
      input.focus({ preventScroll: true });
      if (field.type === 'date') {
        if (typeof input.showPicker === 'function') {
          try { input.showPicker(); return; } catch (e) { /* focus only */ }
        }
        return;
      }
      var len = input.value.length;
      try {
        input.setSelectionRange(len, len);
      } catch (e) {
        input.focus({ preventScroll: true });
      }
    });
  }

  function bindProfileInlineControl(control, field) {
    control.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); control.blur(); }
      else if (e.key === 'Escape') { e.preventDefault(); cancelProfileFieldEdit(); }
    });
    control.addEventListener('blur', function() {
      window.setTimeout(function() {
        if (!profileInlineEdit || profileInlineEdit.input !== control) return;
        commitProfileFieldEdit();
      }, 0);
    });
  }

  async function activateProfileFieldEdit(fieldKey, e) {
    if (!currentUser || !isProfilePage() || accountDetailsEditMode || profileChangePending) return;
    if (fieldKey === 'marketing_opt_in') {
      if (e) e.preventDefault();
      var source = getProfileDataSource(currentUser);
      saveProfileFieldUpdate('marketing_opt_in', !source.marketing_opt_in);
      return;
    }
    if (fieldKey === 'password') {
      if (e) e.preventDefault();
      openPasswordEdit();
      return;
    }
    if (profilePasswordEditOpen) closePasswordEdit(true);
    if (profileInlineEdit && profileInlineEdit.fieldKey === fieldKey) {
      if (e) e.preventDefault();
      focusProfileInlineInput(profileInlineEdit.input, getProfileFieldConfig(fieldKey));
      return;
    }
    if (profileInlineEdit && profileInlineEdit.fieldKey !== fieldKey) {
      await commitProfileFieldEdit();
    }
    if (e) e.preventDefault();
    startProfileFieldEdit(fieldKey);
  }

  async function startProfileFieldEdit(fieldKey) {
    if (!currentUser || !isProfilePage() || profileChangePending) return;
    var field = getProfileFieldConfig(fieldKey);
    if (!field || field.type === 'toggle' || field.type === 'password') return;
    if (profileInlineEdit && profileInlineEdit.fieldKey === fieldKey) return;
    if (profileInlineEdit) await commitProfileFieldEdit();
    var row = document.querySelector('.gm-account-field[data-field="' + fieldKey + '"]');
    if (!row) return;
    var trigger = row.querySelector('.cs-account-value.gm-account-editable') || row.querySelector('.cs-account-value');
    if (!trigger) return;
    var rawValue = getProfileFieldRaw(currentUser, field);
    var control = document.createElement('input');
    control.type = field.type;
    control.className = 'gm-account-inline-input';
    control.id = 'profile-inline-' + fieldKey;
    control.value = rawValue;
    control.setAttribute('aria-label', field.label);
    trigger.replaceWith(control);
    if (field.type === 'date') initTouchDateField(control.id);
    profileInlineEdit = { fieldKey: fieldKey, input: control, originalValue: rawValue };
    bindProfileInlineControl(control, field);
    focusProfileInlineInput(control, field);
  }

  async function commitProfileFieldEdit() {
    if (!profileInlineEdit || !currentUser) return;
    var fieldKey = profileInlineEdit.fieldKey;
    var input = profileInlineEdit.input;
    var newRaw = input.value;
    var oldRaw = profileInlineEdit.originalValue;
    var field = getProfileFieldConfig(fieldKey);
    profileInlineEdit = null;

    if (profileFieldValuesEqual(fieldKey, oldRaw, newRaw)) {
      renderAccountDetails(currentUser);
      return;
    }

    profileChangePending = {
      fieldKey: fieldKey,
      newRaw: newRaw,
      oldRaw: oldRaw,
      field: field
    };
    renderAccountDetails(currentUser);
    showProfileChangeConfirm(profileChangePending);
  }

  function setProfileActivePanel(panel) {
    if (!isProfilePage()) return;
    if (panel !== profileActivePanel) {
      if (profileInlineEdit) cancelProfileFieldEdit();
      if (profileChangePending) cancelProfileChange();
      if (profilePasswordEditOpen) closePasswordEdit(false);
    }
    profileActivePanel = panel;
    document.querySelectorAll('.gm-profile-nav-btn').forEach(function(btn) {
      var isActive = btn.getAttribute('data-profile-panel') === panel;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-current', isActive ? 'page' : 'false');
    });
    document.querySelectorAll('.gm-profile-panel').forEach(function(section) {
      section.classList.toggle('is-active', section.id === 'profile-panel-' + panel);
    });
    if (panel === 'orders' && !window.__gmProfileOrdersLocked) loadMyOrders();
  }

  function applyProfileAccountDetailsLayout() {
    if (!isProfilePage()) return;
    var profileSection = $('profile-section');
    if (profileSection) profileSection.style.cssText = 'width:100%;max-width:100%;box-sizing:border-box;';
    var loggedIn = $('logged-in-view');
    if (loggedIn) {
      loggedIn.style.alignItems = 'center';
      loggedIn.style.width = '100%';
    }
    var panel = $('account-details-panel');
    if (panel) panel.style.cssText = 'width:100%;max-width:100%;max-height:none;opacity:1;overflow:visible;margin-top:0;box-sizing:border-box;';
    var content = $('account-details-content');
    if (content) content.style.cssText = 'display:flex;justify-content:center;width:100%;max-width:100%;box-sizing:border-box;';
  }

  function renderProfileAccountPanel(user) {
    var content = $('account-details-content');
    if (!content || !user) return;
    var styles = getProfileAccountFieldStyles();
    content.classList.add('gm-account-details-view');
    content.classList.remove('gm-account-details-edit');
    content.innerHTML = '<div class="gm-account-details-stack">' +
      PROFILE_ACCOUNT_FIELDS.map(function(field) {
        return buildProfileAccountDetailsRow(
          field,
          getProfileFieldDisplay(user, field),
          getProfileFieldRaw(user, field),
          styles
        );
      }).join('') +
      '</div>';
  }

  function renderAccountDetails(user) {
    var content = $('account-details-content');
    var panel = $('account-details-panel');
    if (!content || !user) return;
    accountDetailsEditMode = false;
    if (panel) panel.classList.remove('is-editing');
    if (isProfilePage()) {
      profileInlineEdit = null;
      renderProfileAccountPanel(user);
      applyProfileAccountDetailsLayout();
      return;
    }
    profilePasswordEditOpen = false;
    content.classList.add('gm-account-details-view');
    content.classList.remove('gm-account-details-edit');
    var meta = user.user_metadata || {};
    var rows = [
      ['first name', meta.firstname],
      ['last name', meta.lastname],
      ['username', meta.username],
      ['email', user.email],
      ['phone', meta.phone],
      ['birthday', meta.birthday],
      ['updates', meta.marketing_opt_in ? 'texts and emails on' : 'texts and emails off']
    ].filter(function(row) { return row[1]; });
    var html;
    if (rows.length === 0) {
      html = '<p class="cs-account-value">no details on file</p>';
    } else {
      html = '<div class="gm-account-details-grid">' + rows.map(function(row) {
        return '<div class="cs-account-row"><span class="cs-account-label">' + row[0] +
          '</span><span class="cs-account-value">' + escHtml(row[1]) + '</span></div>';
      }).join('') + '</div>';
      html += '<button type="button" class="cs-account-edit-btn" id="account-edit-btn">edit</button>';
    }
    content.innerHTML = html;
    if (!isProfilePage()) applyProfileAccountDetailsLayout();
  }

  function renderAccountDetailsEdit(user) {
    var content = $('account-details-content');
    var panel = $('account-details-panel');
    if (!content || !user) return;
    accountDetailsEditMode = true;
    content.classList.remove('gm-account-details-view');
    content.classList.add('gm-account-details-edit');
    if (panel) {
      panel.classList.add('open', 'is-editing');
      panel.setAttribute('aria-hidden', 'false');
    }
    var meta = user.user_metadata || {};
    var marketing = !!meta.marketing_opt_in;
    content.innerHTML =
      '<form class="cs-account-form" id="account-edit-form" novalidate>' +
        '<input class="cs-input" type="text" id="account-edit-firstname" placeholder="first name" value="' + escHtml(meta.firstname) + '" />' +
        '<input class="cs-input" type="text" id="account-edit-lastname" placeholder="last name" value="' + escHtml(meta.lastname) + '" />' +
        '<input class="cs-input" type="text" id="account-edit-username" placeholder="username" value="' + escHtml(meta.username) + '" />' +
        '<input class="cs-input" type="email" id="account-edit-email" placeholder="email" value="' + escHtml(user.email) + '" />' +
        '<input class="cs-input" type="tel" id="account-edit-phone" placeholder="phone number" value="' + escHtml(meta.phone) + '" />' +
        '<input class="cs-input" type="date" id="account-edit-birthday" value="' + escHtml(meta.birthday) + '" />' +
        '<label class="cs-checkbox-field" for="account-edit-marketing">' +
          '<input type="checkbox" id="account-edit-marketing"' + (marketing ? ' checked' : '') + ' />' +
          '<span class="cs-checkbox-label">i agree to receive texts and emails about future drops and new items</span>' +
        '</label>' +
        '<div class="cs-account-form-actions">' +
          '<button type="button" class="cs-account-save-btn" id="account-save-btn">save</button>' +
          '<button type="button" class="cs-account-cancel-btn" id="account-cancel-btn">cancel</button>' +
        '</div>' +
      '</form>';
    initTouchDateField('account-edit-birthday');
  }

  async function applyAccountProfileUpdate(profilePayload) {
    if (!currentUser) return false;
    var token = await getValidAccessToken();
    if (!token) { handleAuthFailure('your session expired — please sign in again'); return false; }
    var email = profilePayload.email;
    var username = profilePayload.username;
    var firstname = profilePayload.firstname;
    var lastname = profilePayload.lastname;
    var phone = profilePayload.phone;
    var birthday = profilePayload.birthday;
    var marketingOptIn = profilePayload.marketing_opt_in;
    var meta = currentUser.user_metadata || {};
    if (username.toLowerCase() !== String(meta.username || '').toLowerCase()) {
      if (await isUsernameTakenByOther(username, currentUser.id)) {
        showAccountMessage('that username is already taken');
        return false;
      }
    }
    hideAccountMessage();
    var previousEmail = currentUser.email;
    var profileSavedPayload = {
      email: email, username: username, firstname: firstname, lastname: lastname,
      phone: phone, birthday: birthday,
      marketing_opt_in: marketingOptIn,
      marketing_opt_in_at: profilePayload.marketing_opt_in_at
    };
    var authBody = {
      email: email !== currentUser.email ? email : undefined,
      data: {
        username: username, firstname: firstname, lastname: lastname, phone: phone, birthday: birthday,
        marketing_opt_in: marketingOptIn
      }
    };
    if (!authBody.email) delete authBody.email;
    var authRes = await fetch(SUPABASE_URL + '/auth/v1/user', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + token },
      body: JSON.stringify(authBody)
    });
    var authData = null;
    try { authData = await authRes.json(); } catch (e) { /* empty */ }
    if (isAuthErrorResponse(authRes, authData)) {
      handleAuthFailure(getErrorText(authData) || 'your session expired — please sign in again');
      return false;
    }
    if (!authRes.ok) {
      showAccountMessage(toUserFacingMessage(getErrorText(authData) || 'could not update your account'));
      return false;
    }
    var profileSaved = await saveUserProfile(token, currentUser.id, profileSavedPayload);
    if (!profileSaved.ok) {
      showAccountMessage('could not save your profile — ' + (profileSaved.error || 'please try again'));
      return false;
    }
    currentProfile = Object.assign({}, currentProfile || {}, profileSavedPayload);
    var updatedUser = authData && authData.id ? authData : await fetchAuthUser(token);
    if (updatedUser) {
      currentUser = updatedUser;
      var session = getStoredSession();
      if (session) { session.user = updatedUser; localStorage.setItem('gm_session', JSON.stringify(session)); }
    }
    var syncResult = await syncMarketingIntegrations(token);
    renderAccountDetails(currentUser);
    if (!syncResult.shopify.ok) {
      showAccountMessage('profile saved, but shopify sync failed — ' + (syncResult.shopify.error || 'please try again'));
      return true;
    }
    if (!syncResult.klaviyo.ok && !syncResult.klaviyo.skipped) {
      showAccountMessage('profile saved, but klaviyo sync failed — ' + (syncResult.klaviyo.error || 'please try again'));
      return true;
    }
    if (syncResult.klaviyo.ok && syncResult.klaviyo.sms_skipped) {
      showAccountMessage('profile updated — email synced; finish klaviyo SMS setup for texts', true);
      return true;
    }
    showAccountMessage(email !== previousEmail ? 'check your email to confirm the new address' : 'profile updated', email === previousEmail);
    return true;
  }

  function buildProfilePayloadFromUser(user, overrides) {
    var source = getProfileDataSource(user);
    var payload = {
      email: source.email || '',
      username: source.username || '',
      firstname: source.firstname || '',
      lastname: source.lastname || '',
      phone: source.phone || '',
      birthday: source.birthday || '',
      marketing_opt_in: !!source.marketing_opt_in,
      marketing_opt_in_at: source.marketing_opt_in ? (source.marketing_opt_in_at || new Date().toISOString()) : null
    };
    if (overrides) {
      for (var key in overrides) {
        if (Object.prototype.hasOwnProperty.call(overrides, key)) payload[key] = overrides[key];
      }
    }
    return payload;
  }

  async function saveProfileFieldUpdate(fieldKey, rawValue) {
    if (!currentUser) return false;
    var overrides = {};
    if (fieldKey === 'email') {
      overrides.email = String(rawValue).trim().toLowerCase();
    } else if (fieldKey === 'marketing_opt_in') {
      overrides.marketing_opt_in = !!rawValue;
      overrides.marketing_opt_in_at = rawValue ? new Date().toISOString() : null;
    } else {
      overrides[fieldKey] = String(rawValue).trim();
    }
    var profilePayload = buildProfilePayloadFromUser(currentUser, overrides);
    var issue = validateProfileFieldValue(fieldKey, profilePayload);
    if (issue) {
      showAccountMessage(issue);
      renderAccountDetails(currentUser);
      return false;
    }
    var ok = await applyAccountProfileUpdate(profilePayload);
    if (!ok) renderAccountDetails(currentUser);
    return ok;
  }

  async function saveAccountDetails() {
    if (!currentUser) return;
    var fields = [
      { id: 'account-edit-firstname', label: 'first name' },
      { id: 'account-edit-lastname', label: 'last name' },
      { id: 'account-edit-username', label: 'username' },
      { id: 'account-edit-email', label: 'email' },
      { id: 'account-edit-phone', label: 'phone number' },
      { id: 'account-edit-birthday', label: 'birthday' }
    ];
    var missing = getAccountEditIssue(fields);
    if (missing) {
      showAccountMessage('please fill out ' + missing.label);
      if (missing.el && missing.el.focus) missing.el.focus();
      return;
    }
    var firstname = $('account-edit-firstname').value.trim();
    var lastname = $('account-edit-lastname').value.trim();
    var username = $('account-edit-username').value.trim();
    var email = $('account-edit-email').value.trim().toLowerCase();
    var phone = $('account-edit-phone').value.trim();
    var birthday = $('account-edit-birthday').value;
    var marketingOptIn = $('account-edit-marketing').checked;
    var profilePayload = buildProfilePayloadFromUser(currentUser, {
      email: email, username: username, firstname: firstname, lastname: lastname,
      phone: phone, birthday: birthday, marketing_opt_in: marketingOptIn,
      marketing_opt_in_at: marketingOptIn ? new Date().toISOString() : null
    });
    await applyAccountProfileUpdate(profilePayload);
  }

  function getTokenExpiry(accessToken) {
    if (!accessToken) return null;
    try {
      var payload = JSON.parse(atob(accessToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return payload.exp || null;
    } catch (e) { return null; }
  }

  function normalizeExpiry(expiresAt) {
    if (!expiresAt) return null;
    var value = Number(expiresAt);
    if (!value) return null;
    return value > 1e12 ? Math.floor(value / 1000) : value;
  }

  function getErrorText(data) {
    if (!data) return '';
    if (typeof data === 'string') return data;
    if (typeof data.error === 'string') return [data.error, data.message, data.error_description].filter(Boolean).join(' ');
    if (data.error && typeof data.error === 'object') return data.error.message || data.error.msg || data.error.error_description || '';
    return data.message || data.error_description || data.msg || '';
  }

  function getFriendlyAuthMessage(message) {
    var msg = String(message || '').toLowerCase();
    if (/access token|expired|revoked|malformed|invalid for other reasons|invalid.*token|jwt|not authenticated/.test(msg)) {
      return 'your session expired — please sign in again';
    }
    return message || 'something went wrong';
  }

  function clearStoredSession() {
    try {
      localStorage.removeItem('gm_session');
    } catch (e) { /* ignore */ }
    clearAuthOptimistic();
  }

  function normalizeSession(data) {
    if (!data || !data.access_token) return null;
    var session = Object.assign({}, data);
    var now = Math.floor(Date.now() / 1000);
    var tokenExp = getTokenExpiry(session.access_token);
    if (tokenExp) session.expires_at = tokenExp;
    else if (!session.expires_at && session.expires_in) session.expires_at = now + Number(session.expires_in);
    else session.expires_at = normalizeExpiry(session.expires_at);
    return session;
  }

  function saveSession(data, previousSession) {
    var session = normalizeSession(data);
    if (!session) return null;
    if ((!session.user || !session.user.id) && previousSession && previousSession.user) session.user = previousSession.user;
    localStorage.setItem('gm_session', JSON.stringify(session));
    return session;
  }

  function getStoredSession() {
    try {
      var raw = localStorage.getItem('gm_session');
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function isSessionFresh(session) {
    if (!session || !session.access_token) return false;
    var now = Math.floor(Date.now() / 1000);
    var expiresAt = normalizeExpiry(session.expires_at) || getTokenExpiry(session.access_token);
    if (!expiresAt) return false;
    session.expires_at = expiresAt;
    return now < expiresAt - SESSION_REFRESH_BUFFER_SEC;
  }

  async function refreshSession(refreshToken, previousSession) {
    if (!refreshToken) return null;
    var res = await fetch(SUPABASE_URL + '/auth/v1/token?grant_type=refresh_token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + SUPABASE_ANON_KEY
      },
      body: JSON.stringify({ refresh_token: refreshToken })
    });
    var data = {};
    try { data = await res.json(); } catch (e) { data = {}; }
    if (!data.access_token) return null;
    return saveSession(data, previousSession);
  }

  async function fetchAuthUser(accessToken) {
    var res = await fetch(SUPABASE_URL + '/auth/v1/user', {
      headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + accessToken }
    });
    var data = await res.json();
    if (!res.ok || !data || !data.id) return null;
    return data;
  }

  function clearAuthOptimistic() {
    document.documentElement.classList.remove('gm-auth-optimistic');
  }

  function emitAuthChange() {
    syncAdminNav();
    window.dispatchEvent(new CustomEvent('gm-auth-change', {
      detail: { user: currentUser, profile: currentProfile }
    }));
  }

  function isAdminUser() {
    return !!(currentProfile && currentProfile.is_admin);
  }

  function syncAdminNav() {
    var show = isAdminUser();
    document.querySelectorAll('[data-gm-admin-nav]').forEach(function(link) {
      link.hidden = !show;
    });
  }

  function showLoggedOut() {
    currentUser = null;
    currentProfile = null;
    profilePasswordEditOpen = false;
    clearAuthOptimistic();
    if (typeof window.gmResetProfileAuthDropdowns === 'function') {
      window.gmResetProfileAuthDropdowns();
    }
    var page = getPageEl();
    if (page) {
      page.classList.add('gm-auth-logged-out');
      page.classList.remove('gm-auth-logged-in');
    }
    var loggedIn = $('logged-in-view');
    var loggedOut = $('logged-out-view');
    if (loggedIn) {
      loggedIn.style.display = 'none';
      loggedIn.setAttribute('hidden', 'hidden');
    }
    if (loggedOut) {
      loggedOut.style.display = 'flex';
      loggedOut.removeAttribute('hidden');
    }
    try {
      setProfilePanelOpen(false);
    } catch (e) {
      /* ignore */
    }
    emitAuthChange();
  }

  async function getValidSession() {
    var session = getStoredSession();
    if (!session) return null;
    if (isSessionFresh(session)) return session;

    var accessTokenBefore = session.access_token || '';
    var refreshToken = session.refresh_token || '';
    if (refreshToken) {
      session = await refreshSession(refreshToken, session);
      if (session && isSessionFresh(session)) return session;
    }

    // A newer login may have saved while refresh was in flight — keep only if still fresh.
    var latest = getStoredSession();
    if (latest && latest.access_token && latest.access_token !== accessTokenBefore && isSessionFresh(latest)) {
      return latest;
    }

    if (!latest || latest.access_token === accessTokenBefore) {
      clearStoredSession();
    }
    return null;
  }

  async function getValidAccessToken() {
    var session = await getValidSession();
    if (!session) return null;
    var user = await fetchAuthUser(session.access_token);
    if (!user) {
      if (session.refresh_token) {
        var refreshed = await refreshSession(session.refresh_token, session);
        if (refreshed && refreshed.access_token) {
          var refreshedUser = await fetchAuthUser(refreshed.access_token);
          if (refreshedUser) {
            refreshed.user = refreshedUser;
            localStorage.setItem('gm_session', JSON.stringify(refreshed));
            return refreshed.access_token;
          }
        }
      }
      clearStoredSession();
      return null;
    }
    if (!session.user || session.user.id !== user.id) {
      session.user = user;
      localStorage.setItem('gm_session', JSON.stringify(session));
    }
    return session.access_token;
  }

  function isAuthErrorResponse(res, data) {
    if (res.status === 401 || res.status === 403) return true;
    return /expired|invalid.*token|access token|jwt|revoked|malformed|not authenticated|invalid for other reasons/i.test(getErrorText(data));
  }

  function handleAuthFailure(message) {
    clearStoredSession();
    showLoggedOut();
    if (message) showAuthPopup(getFriendlyAuthMessage(message));
    if (!isProfilePage()) openAccountOverlay();
  }

  async function syncProfileToShopify(accessToken) {
    if (!accessToken) return { ok: false, error: 'missing session' };
    try {
      var res = await fetch(SUPABASE_URL + '/functions/v1/sync-shopify-customer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + accessToken },
        body: JSON.stringify({})
      });
      var data = null;
      try { data = await res.json(); } catch (e) { /* empty */ }
      if (!res.ok) {
        return { ok: false, error: (data && data.error) || ('sync failed (' + res.status + ')') };
      }
      if (data && data.shopify_customer_id) {
        currentProfile = Object.assign({}, currentProfile || {}, {
          shopify_customer_id: data.shopify_customer_id,
          shopify_synced_at: new Date().toISOString()
        });
      }
      return {
        ok: true,
        shopify_customer_id: data && data.shopify_customer_id
      };
    } catch (e) {
      return { ok: false, error: 'could not reach shopify sync' };
    }
  }

  async function syncProfileToKlaviyo(accessToken, options) {
    if (!accessToken) return { ok: false, error: 'missing session' };
    var body = {};
    if (options && typeof options.marketing_opt_in === 'boolean') {
      body.marketing_opt_in = options.marketing_opt_in;
    }
    if (options && options.force_subscribe) {
      body.force_subscribe = true;
    }
    if (options && options.email) body.email = options.email;
    if (options && options.phone) body.phone = options.phone;
    try {
      var res = await fetch(SUPABASE_URL + '/functions/v1/sync-klaviyo-subscriber', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + accessToken },
        body: JSON.stringify(body)
      });
      var data = null;
      try { data = await res.json(); } catch (e) { /* empty */ }
      if (!res.ok) {
        var failMsg = data && (data.error || data.msg || data.message);
        if (failMsg && typeof failMsg === 'object') {
          failMsg = failMsg.msg || failMsg.message || JSON.stringify(failMsg);
        }
        return {
          ok: false,
          skipped: !!(data && data.skipped),
          error: failMsg || ('klaviyo sync failed (' + res.status + ')')
        };
      }
      if (data) {
        currentProfile = Object.assign({}, currentProfile || {}, {
          klaviyo_profile_id: data.klaviyo_profile_id || (currentProfile && currentProfile.klaviyo_profile_id) || null,
          klaviyo_status: data.klaviyo_status || null,
          klaviyo_synced_at: new Date().toISOString()
        });
      }
      return {
        ok: true,
        skipped: !!(data && data.skipped),
        sms_skipped: !!(data && data.sms_skipped),
        hint: data && data.hint,
        klaviyo_profile_id: data && data.klaviyo_profile_id,
        klaviyo_status: data && data.klaviyo_status
      };
    } catch (e) {
      return { ok: false, error: 'could not reach klaviyo sync' };
    }
  }

  async function syncMarketingIntegrations(accessToken, options) {
    var shopify = await syncProfileToShopify(accessToken);
    var klaviyo = { ok: true, skipped: true };
    try {
      klaviyo = await syncProfileToKlaviyo(accessToken, options);
    } catch (e) {
      klaviyo = { ok: false, error: 'could not reach klaviyo sync' };
    }
    return { shopify: shopify, klaviyo: klaviyo };
  }

  function shopifyRoutesRoot() {
    return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  }

  function isLocalThemePreview() {
    var host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  }

  function storefrontOrigin() {
    if (!isLocalThemePreview()) return window.location.origin;
    if (window.Shopify && Shopify.shop) return 'https://' + Shopify.shop;
    return 'https://vtcius-ge.myshopify.com';
  }

  function goToCheckoutUrl(queryParams, useCartCheckoutPath) {
    var query = queryParams && queryParams.toString ? queryParams.toString() : '';
    var path = useCartCheckoutPath ? 'cart/checkout' : 'checkout';

    // Local theme preview proxies often return HTTP 401 on /checkout.
    // Rebuild the cart on the real storefront domain, then go to checkout.
    if (isLocalThemePreview()) {
      fetchCartLines().then(function(lines) {
        var origin = storefrontOrigin();
        if (lines.length) {
          var permalink = lines.map(function(line) {
            return String(line.variant_id) + ':' + String(line.quantity);
          }).join(',');
          window.location.href = origin + '/cart/' + permalink + (query ? '?' + query + '&' : '?') + 'checkout';
          return;
        }
        window.location.href = origin + '/' + path + (query ? '?' + query : '');
      });
      return;
    }

    var root = shopifyRoutesRoot();
    window.location.href = root + path + (query ? '?' + query : '');
  }

  async function fetchCartLines() {
    var root = shopifyRoutesRoot();
    try {
      var res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return [];
      var cart = await res.json();
      if (!cart || !Array.isArray(cart.items)) return [];
      return cart.items.map(function(item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      }).filter(function(line) { return line.variant_id && line.quantity; });
    } catch (e) {
      return [];
    }
  }

  async function stampCheckoutCartAttributes(user, source, shopifyCustomerId) {
    var root = shopifyRoutesRoot();
    var attributes = {
      gm_supabase_user_id: user.id,
      gm_profile_email: source.email || user.email || ''
    };
    if (shopifyCustomerId) attributes.gm_shopify_customer_id = String(shopifyCustomerId);
    await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  async function requestPreparedCheckoutUrl(token, lines) {
    var res = await fetch(SUPABASE_URL + '/functions/v1/prepare-shopify-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + token
      },
      body: JSON.stringify({ lines: lines })
    });
    var data = null;
    try { data = await res.json(); } catch (e) { /* empty */ }
    if (!res.ok || !data) {
      return { ok: false, error: (data && data.error) || ('prepare checkout failed (' + res.status + ')') };
    }
    return { ok: true, data: data };
  }

  function buildCheckoutPrefillParams(source, user) {
    var params = new URLSearchParams();
    var email = String((source && source.email) || (user && user.email) || '').trim().toLowerCase();
    if (email) params.set('checkout[email]', email);
    if (source && source.firstname) params.set('checkout[shipping_address][first_name]', String(source.firstname).trim());
    if (source && source.lastname) params.set('checkout[shipping_address][last_name]', String(source.lastname).trim());
    if (source && source.phone) params.set('checkout[shipping_address][phone]', String(source.phone).trim());
    return params;
  }

  async function prepareCheckoutAndGo(triggerEl) {
    var token = await getValidAccessToken();
    if (!token) {
      goToCheckoutUrl(null, true);
      return;
    }

    if (triggerEl) {
      triggerEl.disabled = true;
      triggerEl.classList.add('is-busy');
    }

    try {
      var user = currentUser || await fetchAuthUser(token);
      if (!user) {
        goToCheckoutUrl(null, true);
        return;
      }

      await hydrateCurrentProfile(token, user);
      currentUser = user;

      var lines = await fetchCartLines();
      if (!lines.length) {
        goToCheckoutUrl(null, true);
        return;
      }

      var syncResult = await syncMarketingIntegrations(token);
      if (!syncResult.shopify.ok) {
        console.warn('shopify sync before checkout failed:', syncResult.shopify.error);
      }
      if (!syncResult.klaviyo.ok && !syncResult.klaviyo.skipped) {
        console.warn('klaviyo sync before checkout failed:', syncResult.klaviyo.error);
      }

      var source = getProfileDataSource(user);
      var shopifyCustomerId = (currentProfile && currentProfile.shopify_customer_id) || syncResult.shopify.shopify_customer_id;

      try {
        await stampCheckoutCartAttributes(user, source, shopifyCustomerId);
      } catch (e) {
        console.warn('could not stamp checkout cart attributes', e);
      }

      var prepared = await requestPreparedCheckoutUrl(token, lines);
      if (prepared.ok && prepared.data) {
        if (prepared.data.checkout_url) {
          window.location.href = prepared.data.checkout_url;
          return;
        }
        if (prepared.data.checkout_path) {
          var checkoutPath = String(prepared.data.checkout_path);
          if (checkoutPath.indexOf('http') === 0) {
            window.location.href = checkoutPath;
          } else {
            window.location.href = storefrontOrigin() + (checkoutPath.charAt(0) === '/' ? '' : '/') + checkoutPath;
          }
          return;
        }
      } else if (prepared.error) {
        console.warn('prepare-shopify-checkout failed:', prepared.error);
      }

      goToCheckoutUrl(buildCheckoutPrefillParams(source, user), true);
    } finally {
      if (triggerEl) {
        triggerEl.disabled = false;
        triggerEl.classList.remove('is-busy');
      }
    }
  }

  function initCheckoutLinking() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-gm-checkout]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      prepareCheckoutAndGo(btn);
    });
  }

  window.__gmAuth = {
    getCurrentUser: function() { return currentUser; },
    getCurrentProfile: function() { return currentProfile; },
    getValidAccessToken: getValidAccessToken,
    hydrateCurrentProfile: hydrateCurrentProfile,
    isAdmin: isAdminUser
  };

  window.__gmCheckout = {
    prepareAndGo: prepareCheckoutAndGo
  };

  function renderMyOrdersEmpty(message) {
    var content = $('profile-orders-content');
    if (!content) return;
    content.innerHTML = '<p class="gm-profile-orders-empty">' +
      escHtml(message || 'you haven\u2019t placed any orders yet.') +
    '</p>';
  }

  function getGmOrdersScriptSrc() {
    var scripts = document.querySelectorAll('script[src*="gm-auth.js"]');
    if (!scripts.length) return null;
    return String(scripts[scripts.length - 1].src).replace('gm-auth.js', 'gm-orders-v2.js');
  }

  function ensureGmOrdersLoaded(maxMs) {
    maxMs = maxMs || 6000;
    if (window.__gmOrders && typeof window.__gmOrders.renderProfileOrders === 'function') {
      return Promise.resolve(window.__gmOrders);
    }
    if (window.__gmOrders && typeof window.__gmOrders.waitForGmOrders === 'function') {
      return window.__gmOrders.waitForGmOrders(maxMs);
    }
    return new Promise(function(resolve) {
      var done = false;
      function finish(api) {
        if (done) return;
        done = true;
        window.removeEventListener('gm-orders-ready', onReady);
        resolve(api || null);
      }
      function onReady() {
        finish(window.__gmOrders || null);
      }
      window.addEventListener('gm-orders-ready', onReady);

      if (!document.querySelector('script[src*="gm-orders-v2.js"], script[src*="gm-orders.js"]')) {
        var src = getGmOrdersScriptSrc();
        if (src) {
          if (src.indexOf('gmcb=') < 0) {
            src += (src.indexOf('?') >= 0 ? '&' : '?') + 'gmcb=20260802noflash';
          }
          var script = document.createElement('script');
          script.src = src;
          script.defer = true;
          script.setAttribute('data-gm-orders-loader', '1');
          document.head.appendChild(script);
        }
      }

      window.setTimeout(function() {
        finish(window.__gmOrders || null);
      }, maxMs);
    });
  }

  var profileOrdersLoadPromise = null;

  async function loadMyOrders() {
    var content = $('profile-orders-content');
    if (!content) return;
    if (window.__gmProfileOrdersLocked || content.dataset.gmOrdersReady === '1') return;
    if (content.querySelector('.gm-order-track-view')) {
      window.__gmProfileOrdersLocked = true;
      content.dataset.gmOrdersReady = '1';
      return;
    }
    if (window.__gmProfileOrdersLoadStarted) {
      return profileOrdersLoadPromise || Promise.resolve();
    }
    window.__gmProfileOrdersLoadStarted = true;
    if (profileOrdersLoadPromise) return profileOrdersLoadPromise;

    profileOrdersLoadPromise = (async function() {
      var ordersApi = await ensureGmOrdersLoaded(6000);

      if (!ordersApi || typeof ordersApi.renderProfileOrders !== 'function') {
        renderMyOrdersEmpty('orders could not load — refresh the page');
        return;
      }

      function shouldUsePreviewProfileOrders() {
        if (!isLocalThemePreview()) return false;
        var search = window.location.search || '';
        var hash = window.location.hash || '';
        try {
          if (localStorage.getItem('gm-preview-profile-orders') === '1') return true;
        } catch (e) { /* ignore */ }
        return /(?:\?|&)preview_orders=1(?:&|$)/.test(search) ||
          /preview_orders=1/.test(hash);
      }

      if (shouldUsePreviewProfileOrders() && typeof ordersApi.getPreviewOrders === 'function') {
        var previewOrders = await ordersApi.getPreviewOrders();
        if (typeof ordersApi.preloadOrderImages === 'function') {
          await ordersApi.preloadOrderImages(previewOrders);
        }
        ordersApi.renderProfileOrders(content, previewOrders);
        window.__gmProfileOrdersLocked = true;
        content.dataset.gmOrdersReady = '1';
        injectProfilePastGridStyles();
        return;
      }

      var token = await getValidAccessToken();
      if (!token) {
        renderMyOrdersEmpty();
        return;
      }

      var result = await ordersApi.fetchMyOrders(token);
      if (!result.ok) {
        renderMyOrdersEmpty(result.error || 'could not load orders');
        return;
      }

      if (!result.orders.length) {
        renderMyOrdersEmpty();
        window.__gmProfileOrdersLocked = true;
        content.dataset.gmOrdersReady = '1';
        return;
      }

      if (typeof ordersApi.preloadOrderImages === 'function') {
        await ordersApi.preloadOrderImages(result.orders);
      }
      ordersApi.renderProfileOrders(content, result.orders, result.hint);
      window.__gmProfileOrdersLocked = true;
      content.dataset.gmOrdersReady = '1';
      injectProfilePastGridStyles();
    })().finally(function() {
      profileOrdersLoadPromise = null;
    });

    return profileOrdersLoadPromise;
  }

  async function hydrateCurrentProfile(token, user) {
    if (!token || !user || !user.id) {
      mergeProfileRow(null);
      return null;
    }
    var profileRow = await fetchUserProfileRow(token, user.id);
    mergeProfileRow(profileRow);
    return profileRow;
  }

  function showLoggedIn(user, isReturning) {
    currentUser = user;
    clearAuthOptimistic();
    var page = getPageEl();
    if (page) {
      page.classList.add('gm-auth-logged-in');
      page.classList.remove('gm-auth-logged-out');
    }
    var loggedOut = $('logged-out-view');
    var loggedIn = $('logged-in-view');
    if (loggedOut) {
      loggedOut.style.display = 'none';
      loggedOut.classList.remove('is-open');
      loggedOut.setAttribute('hidden', 'hidden');
    }
    if (loggedIn) {
      loggedIn.style.display = 'flex';
      loggedIn.removeAttribute('hidden');
    }
    if (typeof window.gmCloseProfileAuth === 'function') {
      window.gmCloseProfileAuth();
    }
    renderAccountDetails(user);
    setProfileActivePanel(getInitialProfilePanel());
    try {
      setProfilePanelOpen(false);
    } catch (e) {
      /* ignore legacy profile-toggle label errors */
    }
    emitAuthChange();
  }

  async function checkSession() {
    var hadSession = !!localStorage.getItem('gm_session');
    var sessionAtStart = getStoredSession();
    var accessTokenAtStart = sessionAtStart && sessionAtStart.access_token;
    var session = await getValidSession();
    if (!session || !session.access_token) {
      var latest = getStoredSession();
      if (latest && isSessionFresh(latest)) {
        session = latest;
      } else {
        clearStoredSession();
        showLoggedOut();
        return;
      }
    }

    var user = await fetchAuthUser(session.access_token);
    if (user) {
      session.user = user;
      localStorage.setItem('gm_session', JSON.stringify(session));
      try {
        await hydrateCurrentProfile(session.access_token, user);
      } catch (e) { /* keep session even if profile row fetch fails */ }
      showLoggedIn(user, true);
      syncMarketingIntegrations(session.access_token, {
        marketing_opt_in: !!getProfileDataSource(user).marketing_opt_in,
        force_subscribe: true
      });
      return;
    }

    if (session.refresh_token) {
      var refreshed = await refreshSession(session.refresh_token, session);
      if (refreshed && refreshed.access_token) {
        var refreshedUser = refreshed.user || await fetchAuthUser(refreshed.access_token);
        if (refreshedUser) {
          refreshed.user = refreshedUser;
          localStorage.setItem('gm_session', JSON.stringify(refreshed));
          try {
            await hydrateCurrentProfile(refreshed.access_token, refreshedUser);
          } catch (e) { /* ignore */ }
          showLoggedIn(refreshedUser, true);
          return;
        }
      }
    }

    var still = getStoredSession();
    if (still && still.access_token && still.access_token !== accessTokenAtStart && isSessionFresh(still)) {
      return;
    }

    clearStoredSession();
    showLoggedOut();
    // Only nudge the user if they had a session and are on profile (avoid scaring sign-in).
    if (hadSession && isProfilePage() && !($('signin-form') && $('signin-form').style.display === 'flex')) {
      showAuthPopup('your session expired — please sign in again');
    }
  }

  function hideAuthPopup() {
    var messageEl = $('form-message');
    var noticeEl = $('auth-notice');
    var signinErrorEl = $('signin-error');
    var signupErrorEl = $('signup-error');
    if (messageEl) { messageEl.classList.remove('visible'); messageEl.textContent = ''; }
    if (noticeEl) { noticeEl.classList.remove('visible'); noticeEl.textContent = ''; }
    if (signinErrorEl) {
      signinErrorEl.classList.remove('is-visible');
      signinErrorEl.textContent = '';
      signinErrorEl.setAttribute('aria-hidden', 'true');
    }
    if (signupErrorEl) {
      signupErrorEl.classList.remove('is-visible');
      signupErrorEl.textContent = '';
      signupErrorEl.setAttribute('aria-hidden', 'true');
    }
    if (authPopupTimer) clearTimeout(authPopupTimer);
  }

  function showAuthPopup(message) {
    var friendly = getFriendlyAuthMessage(message);
    var messageEl = $('form-message');
    var noticeEl = $('auth-notice');
    var signinErrorEl = $('signin-error');
    var signupErrorEl = $('signup-error');
    var signinVisible = signinFormEl && signinFormEl.style.display !== 'none';
    var signupVisible = signupFormEl && signupFormEl.style.display !== 'none';

    if (signinVisible && signinErrorEl) {
      if (messageEl) { messageEl.classList.remove('visible'); messageEl.textContent = ''; }
      if (noticeEl) { noticeEl.classList.remove('visible'); noticeEl.textContent = ''; }
      if (signupErrorEl) {
        signupErrorEl.classList.remove('is-visible');
        signupErrorEl.textContent = '';
        signupErrorEl.setAttribute('aria-hidden', 'true');
      }
      signinErrorEl.textContent = friendly;
      signinErrorEl.classList.add('is-visible');
      signinErrorEl.setAttribute('aria-hidden', 'false');
    } else if (signupVisible && signupErrorEl) {
      if (messageEl) { messageEl.classList.remove('visible'); messageEl.textContent = ''; }
      if (noticeEl) { noticeEl.classList.remove('visible'); noticeEl.textContent = ''; }
      if (signinErrorEl) {
        signinErrorEl.classList.remove('is-visible');
        signinErrorEl.textContent = '';
        signinErrorEl.setAttribute('aria-hidden', 'true');
      }
      signupErrorEl.textContent = friendly;
      signupErrorEl.classList.add('is-visible');
      signupErrorEl.setAttribute('aria-hidden', 'false');
    } else {
      if (messageEl) { messageEl.textContent = friendly; messageEl.classList.add('visible'); }
      if (noticeEl) { noticeEl.textContent = friendly; noticeEl.classList.add('visible'); }
    }

    if (authPopupTimer) clearTimeout(authPopupTimer);
    authPopupTimer = setTimeout(hideAuthPopup, 5000);
  }

  function isSignupFormVisible() {
    return signinFormEl && signinFormEl.style.display === 'none';
  }

  function usesProfileAuthChoices() {
    return !!document.getElementById('profile-auth-choices');
  }

  function openProfileAuthMode(mode) {
    if (typeof window.gmOpenProfileAuth === 'function') {
      window.gmOpenProfileAuth(mode);
      return;
    }
    setProfilePanelOpen(true);
    if (mode === 'signup') showSignupForm();
    else showSigninForm();
  }

  function closeProfileAuthMode() {
    if (typeof window.gmCloseProfileAuth === 'function') {
      window.gmCloseProfileAuth();
      return;
    }
    setProfilePanelOpen(false);
  }

  function setProfileActionButtons(mode) {
    if (!profileSigninBtn || !profileToggleBtn || !profileInstagramBtn) return;
    if (mode === 'signup') {
      profileSigninBtn.style.display = 'none';
      profileToggleBtn.style.display = '';
      profileInstagramBtn.style.display = 'none';
    } else if (mode === 'signin') {
      profileSigninBtn.style.display = '';
      profileToggleBtn.style.display = 'none';
      profileInstagramBtn.style.display = 'none';
    } else {
      profileSigninBtn.style.display = '';
      profileToggleBtn.style.display = '';
      profileInstagramBtn.style.display = '';
    }
  }

  function setProfilePanelOpen(isOpen) {
    if (!profileDropdown || !loggedOutViewEl) return;
    profileDropdown.classList.toggle('open', isOpen);
    loggedOutViewEl.classList.toggle('is-open', isOpen);
    if (!isOpen) {
      if (profileToggleBtn) profileToggleBtn.textContent = PROFILE_CREATE_CLOSED;
      if (profileSigninBtn) profileSigninBtn.textContent = PROFILE_SIGNIN_CLOSED;
      setProfileActionButtons('both');
    } else if (isSignupFormVisible()) {
      if (profileToggleBtn) profileToggleBtn.textContent = PROFILE_LABEL_OPEN;
    } else {
      if (profileSigninBtn) profileSigninBtn.textContent = PROFILE_LABEL_OPEN;
    }
  }

  function showSignupForm() {
    if (!signupFormEl || !signinFormEl) return;
    signupFormEl.style.display = 'flex';
    signinFormEl.style.display = 'none';
    if (profileDropdown && profileDropdown.classList.contains('open')) {
      if (profileToggleBtn) profileToggleBtn.textContent = PROFILE_LABEL_OPEN;
      if (profileSigninBtn) profileSigninBtn.textContent = PROFILE_SIGNIN_CLOSED;
      setProfileActionButtons('signup');
    }
  }

  function showSigninForm() {
    if (!signupFormEl || !signinFormEl) return;
    signupFormEl.style.display = 'none';
    signinFormEl.style.display = 'flex';
    if (profileToggleBtn) profileToggleBtn.textContent = PROFILE_CREATE_CLOSED;
    if (profileDropdown && profileDropdown.classList.contains('open')) {
      if (profileSigninBtn) profileSigninBtn.textContent = PROFILE_LABEL_OPEN;
      setProfileActionButtons('signin');
    }
  }

  function getFirstMissingSignupField() {
    var fields = [
      { id: 'signup-firstname', label: 'first name' }, { id: 'signup-lastname', label: 'last name' },
      { id: 'signup-username', label: 'username' }, { id: 'signup-email', label: 'email' },
      { id: 'signup-password', label: 'password' }, { id: 'signup-phone', label: 'phone number' },
      { id: 'signup-birthday', label: 'birthday' }
    ];
    for (var i = 0; i < fields.length; i++) {
      var el = $(fields[i].id);
      if (!el) continue;
      var value = el.type === 'password' ? el.value : el.value.trim();
      if (!value) return { el: el, label: fields[i].label };
    }
    return null;
  }

  function normalizeLoginIdentifier(login) {
    var value = String(login || '').trim();
    if (!value) return '';
    if (value.charAt(0) === '@') value = value.slice(1).trim();
    return value;
  }

  async function resolveLoginEmail(login) {
    var value = normalizeLoginIdentifier(login);
    if (!value) return null;
    if (value.indexOf('@') !== -1) return value.toLowerCase();

    var headers = {
      apikey: SUPABASE_ANON_KEY,
      Authorization: 'Bearer ' + SUPABASE_ANON_KEY,
      'Content-Type': 'application/json'
    };

    // Username → email only via security-definer RPC (no public email SELECT).
    try {
      var rpcRes = await fetch(SUPABASE_URL + '/rest/v1/rpc/resolve_login_email', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ identifier: value })
      });
      if (rpcRes.ok) {
        var rpcEmail = await rpcRes.json();
        if (typeof rpcEmail === 'string' && rpcEmail.indexOf('@') !== -1) {
          return rpcEmail.toLowerCase();
        }
      }
    } catch (e) { /* ignore */ }

    return null;
  }

  function getSignInErrorMessage(data, res) {
    var text = getErrorText(data).toLowerCase();
    var code = String((data && (data.error_code || data.code)) || '');
    var combined = text + ' ' + code;
    if (/email_not_confirmed|not confirmed/.test(combined)) {
      return 'confirm your email before signing in';
    }
    if (/too many|rate limit|over_request/.test(combined)) {
      return 'too many sign in attempts — wait a moment and try again';
    }
    if (/access token|expired|revoked|malformed|invalid for other reasons|jwt/.test(combined)) {
      return 'your session expired — please sign in again';
    }
    if (!res || res.status >= 500) {
      return 'sign in temporarily unavailable — try again';
    }
    return 'incorrect credentials';
  }

  function getSignUpErrorMessage(data, res) {
    var text = getErrorText(data);
    var lower = String(text || '').toLowerCase();
    var code = String((data && (data.error_code || data.code)) || '').toLowerCase();
    var combined = lower + ' ' + code;
    if (/user_already_exists|already registered|already been registered|already exists/.test(combined)) {
      return 'an account with that email already exists — try signing in';
    }
    if (/weak_password|at least \d+ characters|password/.test(combined) && /weak|short|characters|least/.test(combined)) {
      return text || 'password is too weak — use at least 6 characters';
    }
    if (/email_address_invalid|invalid.*email|valid email/.test(combined)) {
      return 'please enter a valid email';
    }
    if (/too many|rate limit|over_request|email rate/.test(combined)) {
      return 'too many sign up attempts — wait a moment and try again';
    }
    if (text) return getFriendlyAuthMessage(text);
    if (!res || res.status >= 500) {
      return 'sign up temporarily unavailable — try again';
    }
    return 'could not create account — try again';
  }

  async function attemptSignIn() {
    var loginInput = $('signin-login');
    var passwordInput = $('signin-password');
    var login = normalizeLoginIdentifier(loginInput && loginInput.value);
    var password = passwordInput ? passwordInput.value : '';
    hideAuthPopup();

    if (!login || !password) {
      showAuthPopup('email or username and password required');
      return;
    }

    // Drop any stale/revoked session so refresh races cannot overwrite a fresh login.
    clearStoredSession();

    try {
      var email = await resolveLoginEmail(login);
      if (!email) {
        showAuthPopup('incorrect credentials');
        return;
      }

      // Password grant should use the anon apikey only (no user Bearer token).
      var res = await fetch(SUPABASE_URL + '/auth/v1/token?grant_type=password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY
        },
        body: JSON.stringify({ email: email, password: password })
      });

      var data = {};
      try {
        data = await res.json();
      } catch (e) {
        data = {};
      }

      // Success is determined by an access token, not by legacy `error` field shape.
      if (!data.access_token) {
        showAuthPopup(getSignInErrorMessage(data, res));
        return;
      }

      hideAuthPopup();
      saveSession(data);

      var user = data.user;
      try {
        if (!user || !user.id) {
          user = await fetchAuthUser(data.access_token);
        }
        if (user) {
          var stored = getStoredSession() || data;
          stored.user = user;
          localStorage.setItem('gm_session', JSON.stringify(stored));
          await hydrateCurrentProfile(data.access_token, user);
        }
      } catch (e) {
        /* keep the saved session even if profile hydration fails */
      }

      var signInOptIn = !!(user && getProfileDataSource(user).marketing_opt_in);
      try {
        await syncMarketingIntegrations(data.access_token, {
          marketing_opt_in: signInOptIn,
          force_subscribe: true
        });
      } catch (e) {
        console.warn('marketing sync after sign in failed', e);
      }

      if (user && user.id) {
        showLoggedIn(user, false);
      } else {
        showAuthPopup('signed in — refresh if profile does not appear');
      }
    } catch (e) {
      showAuthPopup('could not reach sign in — check your connection and try again');
    }
  }

  async function attemptSignUp() {
    var firstnameEl = $('signup-firstname');
    var lastnameEl = $('signup-lastname');
    var usernameEl = $('signup-username');
    var emailEl = $('signup-email');
    var passwordEl = $('signup-password');
    var phoneEl = $('signup-phone');
    var birthdayEl = $('signup-birthday');
    var marketingEl = $('signup-marketing-opt-in');
    if (!firstnameEl || !lastnameEl || !usernameEl || !emailEl || !passwordEl || !phoneEl || !birthdayEl) {
      showAuthPopup('sign up form is unavailable — refresh and try again');
      return;
    }

    var firstname = firstnameEl.value.trim();
    var lastname = lastnameEl.value.trim();
    var username = usernameEl.value.trim();
    var email = emailEl.value.trim();
    var password = passwordEl.value;
    var phone = phoneEl.value.trim();
    var birthday = birthdayEl.value;
    var marketingOptIn = !!(marketingEl && marketingEl.checked);
    var missingField = getFirstMissingSignupField();
    if (missingField) {
      showAuthPopup('please fill out ' + missingField.label);
      missingField.el.focus();
      return;
    }
    hideAuthPopup();

    try {
      var res = await fetch(SUPABASE_URL + '/auth/v1/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY },
        body: JSON.stringify({
          email: email, password: password,
          data: { username: username, firstname: firstname, lastname: lastname, phone: phone, birthday: birthday, marketing_opt_in: marketingOptIn }
        })
      });
      var data = {};
      try { data = await res.json(); } catch (e) { data = {}; }

      // Supabase often returns { msg, error_code } without a nested `error` object.
      if (!data.access_token) {
        if (data.user && data.user.id && !getErrorText(data)) {
          showAuthPopup('check your email to confirm your account, then sign in');
          return;
        }
        showAuthPopup(getSignUpErrorMessage(data, res));
        return;
      }

      saveSession(data);
      var user = data.user;
      try {
        if (user && user.id) {
          await fetch(SUPABASE_URL + '/rest/v1/profiles?on_conflict=id', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json', apikey: SUPABASE_ANON_KEY,
              Authorization: 'Bearer ' + data.access_token,
              Prefer: 'return=minimal,resolution=merge-duplicates'
            },
            body: JSON.stringify({
              id: user.id, email: email, username: username, firstname: firstname,
              lastname: lastname, phone: phone, birthday: birthday,
              marketing_opt_in: marketingOptIn, marketing_opt_in_at: marketingOptIn ? new Date().toISOString() : null
            })
          });
        }
        if (!user || !user.id) {
          user = await fetchAuthUser(data.access_token);
        }
        if (user) {
          var stored = getStoredSession() || data;
          stored.user = user;
          localStorage.setItem('gm_session', JSON.stringify(stored));
          await hydrateCurrentProfile(data.access_token, user);
        }
      } catch (e) {
        /* keep the saved session even if profile upsert/hydration fails */
      }

      try {
        var signupSync = await syncMarketingIntegrations(data.access_token, {
          marketing_opt_in: marketingOptIn,
          force_subscribe: true,
          email: email,
          phone: phone
        });
        if (marketingOptIn && signupSync.klaviyo && !signupSync.klaviyo.ok && !signupSync.klaviyo.skipped) {
          console.warn('klaviyo sync after sign up failed', signupSync.klaviyo.error);
        }
      } catch (e) {
        console.warn('marketing sync after sign up failed', e);
      }

      if (user && user.id) {
        showLoggedIn(user, false);
      } else {
        showAuthPopup('account created — refresh if profile does not appear');
      }
    } catch (e) {
      showAuthPopup('could not reach sign up — check your connection and try again');
    }
  }

  function bindEvents() {
    var accountClose = $('gm-account-close');
    if (accountClose) accountClose.addEventListener('click', closeAccountOverlay);
    if (accountOverlay) {
      accountOverlay.addEventListener('click', function(e) {
        if (e.target === accountOverlay) closeAccountOverlay();
      });
    }

    if (profileSigninBtn && !usesProfileAuthChoices() && profileDropdown) {
      profileSigninBtn.addEventListener('click', function() {
        if (profileDropdown.classList.contains('open') && !isSignupFormVisible()) {
          setProfilePanelOpen(false);
          showSignupForm();
          return;
        }
        setProfilePanelOpen(true);
        showSigninForm();
      });
    }

    if (profileToggleBtn && !usesProfileAuthChoices() && profileDropdown) {
      profileToggleBtn.addEventListener('click', function() {
        if (profileDropdown.classList.contains('open') && !isSignupFormVisible()) {
          showSignupForm();
          return;
        }
        setProfilePanelOpen(!profileDropdown.classList.contains('open'));
        if (profileDropdown.classList.contains('open')) showSignupForm();
      });
    }

    if (usesProfileAuthChoices()) {
      var chatLocked = document.getElementById('chat-locked');
      if (chatLocked) {
        chatLocked.addEventListener('click', function() {
          if (currentUser) return;
          openProfileAuthMode('signup');
        });
      }
    }

    var toggleSignin = $('toggle-to-signin');
    var toggleSignup = $('toggle-to-signup');
    if (toggleSignin) toggleSignin.addEventListener('click', function() { openProfileAuthMode('signin'); });
    if (toggleSignup) toggleSignup.addEventListener('click', function() { openProfileAuthMode('signup'); });

    var signupBtn = $('signup-btn');
    var signinBtn = $('signin-btn');
    if (signupBtn) signupBtn.addEventListener('click', attemptSignUp);
    if (signinBtn) signinBtn.addEventListener('click', attemptSignIn);

    var signinLogin = $('signin-login');
    var signinPassword = $('signin-password');
    if (signinPassword) {
      signinPassword.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); attemptSignIn(); }
      });
    }
    [signinLogin, signinPassword].forEach(function(el) {
      if (!el) return;
      el.addEventListener('input', hideAuthPopup);
    });

    var profileSectionsContent = document.querySelector('.gm-profile-sections-content');
    if (profileSectionsContent) {
      profileSectionsContent.addEventListener('change', function(e) {
        var updatesInput = e.target.closest('.gm-account-updates-input');
        if (!updatesInput) return;
        handleUpdatesCheckboxChange(updatesInput);
      });
      profileSectionsContent.addEventListener('click', function(e) {
        if (e.target.id === 'profile-password-save') {
          e.preventDefault();
          submitPasswordChange();
          return;
        }
        if (e.target.id === 'profile-password-cancel') {
          e.preventDefault();
          closePasswordEdit(true);
          return;
        }
        if (e.target.closest('.gm-account-updates-check')) return;
        if (e.target.closest('.gm-account-password-form')) return;
        if (e.target.closest('.gm-account-editable') && isProfilePage() && currentUser && !accountDetailsEditMode) {
          e.preventDefault();
          return;
        }
        if (e.target.id === 'account-edit-btn') {
          e.preventDefault();
          if (currentUser) renderAccountDetailsEdit(currentUser);
        } else if (e.target.id === 'account-cancel-btn') {
          e.preventDefault();
          hideAccountMessage();
          if (currentUser) renderAccountDetails(currentUser);
        } else if (e.target.id === 'account-save-btn') {
          e.preventDefault();
          saveAccountDetails();
        }
      });
      profileSectionsContent.addEventListener('keydown', function(e) {
        if (!e.target.closest('.gm-account-password-form')) return;
        if (e.key === 'Enter') {
          e.preventDefault();
          submitPasswordChange();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closePasswordEdit(true);
        }
      });
      profileSectionsContent.addEventListener('mousedown', function(e) {
        if (e.target.closest('.gm-account-updates-check')) return;
        if (e.target.closest('.gm-account-password-form')) return;
        var editable = e.target.closest('.gm-account-editable');
        if (!editable || !isProfilePage() || !currentUser || accountDetailsEditMode) return;
        var fieldKey = editable.getAttribute('data-field');
        if (!fieldKey || fieldKey === 'marketing_opt_in') return;
        activateProfileFieldEdit(fieldKey, e);
      });
    }

    var profileSectionsNav = $('profile-sections-nav');
    if (profileSectionsNav) {
      profileSectionsNav.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-profile-panel]');
        if (!btn) return;
        var panel = btn.getAttribute('data-profile-panel');
        setProfileActivePanel(panel);
      });
    }

    var accountContent = $('account-details-content');
    if (accountContent && !profileSectionsContent) {
      accountContent.addEventListener('mousedown', function(e) {
        var editable = e.target.closest('.gm-account-editable');
        if (!editable || !isProfilePage() || !currentUser || accountDetailsEditMode) return;
        var fieldKey = editable.getAttribute('data-field');
        if (!fieldKey) return;
        activateProfileFieldEdit(fieldKey, e);
      });
      accountContent.addEventListener('click', function(e) {
        if (e.target.closest('.gm-account-editable') && isProfilePage() && currentUser && !accountDetailsEditMode) {
          e.preventDefault();
          return;
        }
        if (e.target.id === 'account-edit-btn') {
          e.preventDefault();
          if (currentUser) renderAccountDetailsEdit(currentUser);
        } else if (e.target.id === 'account-cancel-btn') {
          e.preventDefault();
          hideAccountMessage();
          if (currentUser) renderAccountDetails(currentUser);
        } else if (e.target.id === 'account-save-btn') {
          e.preventDefault();
          saveAccountDetails();
        }
      });
    }

    var signoutBtn = $('signout-btn');
    if (signoutBtn) {
      signoutBtn.addEventListener('click', function() {
        localStorage.removeItem('gm_session');
        window.location.reload();
      });
    }
  }

  function injectProfilePastGridStyles() {
    if (!isProfilePage()) return;
    if (document.getElementById('gm-profile-past-grid-styles')) return;
    var style = document.createElement('style');
    style.id = 'gm-profile-past-grid-styles';
    style.textContent = '@media (max-width:749px){.gm-profile-page .gm-order-past-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:1.25rem .65rem!important;justify-content:stretch!important}.gm-profile-page .gm-order-past-card{width:100%!important;min-width:0!important}.gm-profile-page .gm-order-past-title{font-size:.78rem!important;letter-spacing:.08em!important;margin-bottom:.5rem!important}.gm-profile-page .gm-order-past-hero-media,.gm-profile-page .gm-order-past-hero-placeholder{width:min(7.5rem,36vw)!important;height:min(7.5rem,36vw)!important;max-width:100%!important}.gm-profile-page .gm-order-past-thumb,.gm-profile-page .gm-order-past-thumb-more{width:min(2.35rem,11vw)!important;height:min(2.35rem,11vw)!important}.gm-profile-page .gm-order-past-status{font-size:.72rem!important;margin-top:.45rem!important}.gm-profile-page .gm-order-past-items:not(.is-single-item){width:100%!important;max-width:100%!important;gap:.35rem!important}}';
    document.head.appendChild(style);
  }

  injectProfilePastGridStyles();

  document.addEventListener('gm-orders-ready', function() {
    if (isProfilePage() && currentUser && $('profile-orders-content')) {
      if (!window.__gmProfileOrdersLocked) loadMyOrders();
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.gm-page')) return;
    profileDropdown = $('profile-dropdown');
    loggedOutViewEl = $('logged-out-view');
    signupFormEl = $('signup-form');
    signinFormEl = $('signin-form');
    profileToggleBtn = $('profile-toggle-btn');
    profileSigninBtn = $('profile-signin-btn');
    profileInstagramBtn = $('profile-instagram-btn');
    accountOverlay = $('gm-account-overlay');
    bindEvents();
    initCheckoutLinking();
    checkSession();
    if (isProfilePage()) injectProfilePastGridStyles();
  });
})();
